<template>
  <v-container>
    <v-row>
      <v-col v-for="i of referrals" :key="i._id" class="pa-0">
        <v-card max-height="565px" height="100%" max-width="400" class="mx-auto my-12" flat outlined>
          <v-img height="250" :src="userImg(i.image)"></v-img>
          <v-card-title>{{ i.name }}</v-card-title>
          <v-card-text>
            <div class="my-4 text-subtitle-1">
              <Nationality size="20px" :nationality-code="i.countries[0]"></Nationality> • <v-chip small
                :key="i._id + '_cat_' + c" v-for="c of i.categories">{{ c }}</v-chip>
            </div>
            <div style="height:120px; overflow:hidden">{{ i.description }}</div>
          </v-card-text>
          <v-divider class="mx-4"></v-divider>
          <v-card-actions>
            <v-btn color="deep-purple lighten-2" text @click="goToLink(i)">
              {{ $t("message.check_it_out") }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn icon @click="likeReferral(i)" :color="i.liked ? 'primary' : ''">
              <v-icon>mdi-thumb-up</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import Api from "@/services/Api2";
import Nationality from "@/components/displays/NationalityFlag.vue";

export default {
  data() {
    return {
      referrals: []
    };
  },
  components: {
    Nationality
  },
  created() {
    this.getReferrals();
  },
  methods: {
    getReferrals() {
      Api()
        .get(
          "partners/managedacademy/" +
          this.$store.state.managedAcademy +
          "/referrals"
        )
        .then((response) => {
          this.referrals = response.data.data;
        });
    },
    likeReferral(i) {
      Api()
        .post(
          "partners/like/" + i._id
        )
        .then(() => {
          i.liked = true;
        });
    },
    goToLink(i) {
      this.logActivity({
        activityType: "clicked_website",
        objectId: i._id,
        objectType: 'partner',
        value: i.url
      });
      window.open(i.url)
    }
  }
}
</script>

<style scoped></style>